import IBAN from 'iban';

export { emailRegex } from '@insify/global-validation';

export const noSpecialCharRegex = /^[^`~!?@#$%^*<>]*$/;
export const onlyDigitsRegex = /^\d*$/;
export const postalCodeRegex = /^[1-9]\d{3}\s?(?!SA|SD|SS)[A-Z]{2}$/;
export const postalCodeFranceRegex = /^\d{5}$/;
export const noDigitsRegex = /^\D*$/;
export const isoDateRegex = /^[12]\d{3}-[01]\d-[0-3]\d$/;

const noSeparatorsRegex = /^[^.,-]*$/;

// TODO add tests
// TODO don't cast to string, handle undefined and null separately
export const validateIban = (iban: string | undefined | null) => {
  return IBAN.isValid(iban as string) && noSeparatorsRegex.test(iban as string);
};

export const isBSN = (bsn: unknown): boolean => {
  if (typeof bsn !== 'string') {
    return false;
  }
  const noWhitespace = bsn.trim();
  //9 numbers only, no letters or special characters
  // do keep in mind that bsn can start with 0 too
  const bsnRegex = /^\d{9}$/;

  if (!bsnRegex.test(noWhitespace)) {
    return false;
  }

  const digits = noWhitespace.split('').map(Number);
  // Multiply each digit by its position in reverse order
  // Uses the same algorithm as bank account validation but swaps the last multiplier from 1 to -1
  // to avoid accepting valid bank account numbers as BSN
  // end sum should be divisible by 11 with 0 remainder
  const sum =
    digits[0] * 9 +
    digits[1] * 8 +
    digits[2] * 7 +
    digits[3] * 6 +
    digits[4] * 5 +
    digits[5] * 4 +
    digits[6] * 3 +
    digits[7] * 2 +
    digits[8] * -1;

  return sum % 11 === 0;
};

export const number = (value: number | string | null | undefined): boolean => {
  if (typeof value === 'number') {
    return true;
  }
  if (typeof value === 'string') {
    return /^-?[0-9]+(\.[0-9]+)?$/.test(value);
  }
  return false;
};

export const integer = (value: number | string | null | undefined): boolean => {
  if (!number(value)) {
    return false;
  }
  return Number.isInteger(Number(value));
};

export const min =
  (min: number) =>
  (value: number | string | null | undefined): boolean => {
    if (value === undefined || value === null || value === '') {
      return true;
    }
    return Number(value) >= min;
  };

export const max =
  (max: number) =>
  (value: number | string | null | undefined): boolean => {
    if (value === undefined || value === null || value === '') {
      return true;
    }
    return Number(value) <= max;
  };
